@if (router$|async) {
}
<div class="d-flex w-100 flex-column">
  <app-header-top data-rr-shared="true" id="hide-element-mobile"></app-header-top>
  <app-header-middle (toggleMenu)="isCollapsedSubject.next(!isCollapsedSubject.value)"></app-header-middle>
  <app-header-bottom [isCollapsed]="isCollapsed$|async"></app-header-bottom>
</div>


